import { render, staticRenderFns } from "./AudienceSegmentBreakdown.vue?vue&type=template&id=7e2f2b01&scoped=true"
import script from "./AudienceSegmentBreakdown.vue?vue&type=script&lang=js"
export * from "./AudienceSegmentBreakdown.vue?vue&type=script&lang=js"
import style0 from "./AudienceSegmentBreakdown.vue?vue&type=style&index=0&id=7e2f2b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f2b01",
  null
  
)

export default component.exports